import { useQuery } from '@tanstack/react-query'
import { useStore } from '@tanstack/react-store'
import { useEffect } from 'react'
import { api } from 'api'
import { UserListFilter, userListStore } from 'shared/store/userList'
import { checkParam } from 'shared/utils/checkParam'
import { getDateTimeToSubmit } from 'shared/utils/dateFormatting'
import { getBoolean } from 'shared/utils/getBoolean'
import { toaster } from 'uikit/Toaster'

export const useFetchUserList = ({ urlParams }: { urlParams: UserListFilter }) => {
  const { size, page, sort, filter } = useStore(userListStore)

  const payload = {
    page,
    size,
    sort,
    lastName: checkParam(filter.lastName),
    firstName: checkParam(filter.firstName),
    middleName: checkParam(filter.middleName),
    phone: checkParam(filter.phone),
    email: checkParam(filter.email),
    clientId: checkParam(filter.clientId),
    passportNumber: checkParam(filter.passportNumber),
    accountNumber: checkParam(filter.accountNumber),
    contractNumber: checkParam(filter.contractNumber),
    applicationVersion: checkParam(filter.applicationVersion),
    platform: checkParam(filter.platform),
    identification: checkParam(filter.identification),
    identificationDateFrom: checkParam(getDateTimeToSubmit(filter.identificationDateFrom)),
    identificationDateTo: checkParam(getDateTimeToSubmit(filter.identificationDateTo)),
    registrationDateFrom: checkParam(getDateTimeToSubmit(filter.registrationDateFrom)),
    registrationDateTo: checkParam(getDateTimeToSubmit(filter.registrationDateTo)),
    enabled: filter?.enabled ? JSON.parse(filter.enabled) : undefined,
    identityCountry: checkParam(filter.identityCountry),
    trusted: getBoolean(filter?.trusted),
    isIDXApproved: filter.isIDXApproved ? JSON.parse(filter.isIDXApproved) : undefined,
    inRkl: getBoolean(filter?.inRkl),
    ...urlParams,
  }

  const response = useQuery({
    queryKey: ['userList', payload],
    queryFn: () => api.users.fetchUserList(payload),
  })

  useEffect(() => {
    if (response.isSuccess) {
      const { totalElements, totalPages } = response.data

      userListStore.setState((state) => ({
        ...state,
        totalElements,
        totalPages,
      }))
    }
  }, [response.isSuccess, response.data])

  useEffect(() => {
    if (response.isError) {
      toaster.create({
        title: 'Не удалось загрузить список пользователей',
        description: response.error?.message,
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    }
  }, [response.isError])

  return response
}
